import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

export const useWindowResize = (onResize: (w: Window) => void) => {
  useIsomorphicLayoutEffect(() => {
    onResize(window);

    const listener = () => {
      onResize(window);
    };

    window.addEventListener('resize', listener, false);
    return () => {
      window.removeEventListener('resize', listener);
    };
  }, [onResize]);
};
